import { ORG_TABLEAU_DASHBOARDS } from './constants';
import { getUserOrg } from './user';

export const validateTableauAccess = () => {
  const organization = getUserOrg();

  if (organization) {
    const options = ORG_TABLEAU_DASHBOARDS[organization];
    return options;
  }
  return null;
};
